var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavbaricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.17731 0 0 7.17731 0 16C0 24.8227 7.17731 32 16 32C24.8227 32 32 24.8227 32 16C32 7.17731 24.8227 0 16 0ZM20.9427 16.9427L14.276 23.6093C14.016 23.8693 13.6747 24 13.3333 24C12.992 24 12.6506 23.8693 12.3906 23.6093C11.8693 23.088 11.8693 22.2453 12.3906 21.724L18.1147 16L12.3907 10.276C11.8694 9.75469 11.8694 8.912 12.3907 8.39069C12.912 7.86938 13.7547 7.86938 14.276 8.39069L20.9427 15.0574C21.464 15.5787 21.464 16.4213 20.9427 16.9427Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbaricon);
export default __webpack_public_path__ + "static/media/navbaricon.5ea3a2712391e6fbf133c9f0a1d9387d.svg";
export { ForwardRef as ReactComponent };